import { FileText } from 'lucide-react';
import { CannedReportsCard } from '../components/historian/CannedReportsCard';
import { DailyOperationsReportsCard } from '../components/reports/DailyOperationsReportsCard';

export function Reports() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <FileText className="w-5 h-5 text-ems-green" />
        <div>
          <h1 className="text-lg font-bold text-ems-text-primary">Reports</h1>
          <p className="text-sm text-ems-text-muted">
            Daily operations PDFs and canned historian reports.
          </p>
        </div>
      </div>

      <DailyOperationsReportsCard />
      <CannedReportsCard />
    </div>
  );
}
